import { useMemo, useState } from "react";
import * as CONST from "../../app/constants";
import { Header, NavigationLinkButton } from "../RegularComponents";

import "./AgentCard.style.scss";
// import ApplicationDraftIcon from "./icons/CONST.APPLICATION_continue_drafting.png"
// import ApplicationActionRequired from "./icons/CONST.APPLICATION_action_required.png"
// import ApplicationRejected from "./icons/CONST.APPLICATION_rejected.png"
// import ApplicationSubmitted from "./icons/CONST.APPLICATION_submitted.png"
// import ApplicationWithdrawn from './icons/CONST.APPLICATION_withdrawn.png'
// import LicenceActive from "./icons/CONST.LICENCE_active.png"
// import LicenceCancelled from "./icons/CONST.LICENCE_cancelled.png"
// import LicenceExpired from "./icons/CONST.LICENCE_expired.png"
// import LicenceSuspended from './icons/CONST.LICENCE_suspended.png'
import { Button } from "../../components/RegularComponents";
import {
  applicationTypeFromLicenceSubType,
  isRenewalTypeLicencingSubType,
  titleStringFromLicenceSubType
} from "../../redux/slice/applicationsUtils";
import { fetchApplicationWithIdAndSetStore } from "../../redux/slice/collectionApplicationSlice";
import { useDispatch } from "react-redux";
import {
  setCurrentAgentApplicationId,
  // setCurrentAgentApplicationStatus,
  withdrawAgentApplication
} from "../../redux/slice/additionalApplicationsSlice";
import { saveBusinessLicenceApplicationData } from "../../redux/slice/businessLicenceApplicationSlice";
import Modal from "react-modal";
import { humanReadableDate } from "../../app/utils";

export const AgentCard = (props) => {
  const { agentApplication, onActionClick } = props;
  const dispatch = useDispatch();

  const [showLicenceCancelDialog, setShowLicenceCancelDialog] = useState(false);
  const [showLicenceCancelSpinner, setShowLicenceCancelSpinner] = useState(false);

  const {
    licenceStatus,
    licenceNumber,
    endDate,
    agentName,
    licencingSubType,
    markedDoNotRenew,
    applicationStatus,
    isAgentRenewalEnable,
    cepRipExpiryDate
  } = agentApplication;

  // const iconFromApplicationStatus = () => {

  //     if (licenceStatus === CONST.LICENCE_STATUS_ACTIVE) {
  //         return LicenceActive
  //     } else if (licenceStatus === CONST.LICENCE_STATUS_EXPIRED) {
  //         return LicenceExpired
  //     } else if (licenceStatus === CONST.LICENCE_STATUS_SUSPENDED) {
  //         return LicenceSuspended
  //     } else if (licenceStatus === CONST.LICENCE_STATUS_REVOKED) {
  //         return LicenceCancelled
  //     } else if (licenceStatus === CONST.LICENCE_STATUS_WITHDRAWN) {
  //         return ApplicationWithdrawn
  //     } else if (licenceStatus === CONST.APPLICATION_STATUS_SUBMITTED) {
  //         return ApplicationSubmitted
  //     } else if (licenceStatus === CONST.APPLICATION_STATUS_DENIED) {
  //         return ApplicationRejected
  //     } else if (licenceStatus === CONST.APPLICATION_STATUS_CANCELLED) {
  //         return ApplicationRejected
  //     } else if (licenceStatus === CONST.APPLICATION_STATUS_UNDER_REVIEW) {
  //         return ApplicationSubmitted
  //     } else if (licenceStatus === CONST.APPLICATION_STATUS_UNREAD) {
  //         return ApplicationSubmitted
  //     } else if (licenceStatus === CONST.APPLICATION_STATUS_PENDING
  //         || licenceStatus === CONST.APPLICATION_STATUS_PENDING_AGENCY) {
  //         return ApplicationSubmitted
  //     } else if (licenceStatus === CONST.APPLICATION_STATUS_PENDING_PAYMENT) {
  //         return ApplicationDraftIcon
  //     } else if (licenceStatus === CONST.APPLICATION_STATUS_ACTION_REQUIRED) {
  //         return ApplicationActionRequired
  //     }

  //     return ApplicationDraftIcon
  // }

  const agentLicenceStatusComponent = (licenceSubType) => {
    if (licenceStatus === CONST.LICENCE_STATUS_ACTIVE) {
      //For document uplaod - applications status is initially set to UNREAD
      if (
        applicationStatus === CONST.APPLICATION_STATUS_UNREAD ||
        applicationStatus === CONST.APPLICATION_STATUS_OPENED ||
        applicationStatus === CONST.APPLICATION_STATUS_UNDER_REVIEW ||
        applicationStatus === CONST.APPLICATION_STATUS_PENDING
      ) {
        return <span className="active">Pending</span>;
      }
      return <span className="active">Active</span>;
    } else if (licenceStatus === CONST.LICENCE_STATUS_EXPIRED) {
      return <span className="expired">Expired</span>;
    } else if (licenceStatus === CONST.LICENCE_STATUS_SUSPENDED) {
      return <span className="suspended">Suspended</span>;
    } else if (licenceStatus === CONST.LICENCE_STATUS_REVOKED) {
      return <span className="revoked">Revoked</span>;
    } else if (licenceStatus === CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT) {
      return <span className="denied">Cancelled by client</span>;
    } else if (licenceStatus === CONST.APPLICATION_STATUS_WITHDRAWN_APPROVED) {
      return <span className="denied">Cancelled</span>;
    } else if (licenceStatus === CONST.APPLICATION_STATUS_SUBMITTED) {
      if (isRenewalTypeLicencingSubType(licencingSubType)) {
        return <span className="submitted">Submitted for renewal</span>;
      }
      return <span className="submitted">Submitted</span>;
    } else if (licenceStatus === CONST.APPLICATION_STATUS_DENIED) {
      return <span className="denied">Denied</span>;
    } else if (licenceStatus === CONST.APPLICATION_STATUS_CANCELLED) {
      return <span className="denied">Cancelled</span>;
    } else if (licenceStatus === CONST.APPLICATION_STATUS_UNDER_REVIEW) {
      if (isRenewalTypeLicencingSubType(licencingSubType)) {
        return <span className="submitted">Submitted for renewal</span>;
      }
      return <span className="submitted">Submitted</span>;
    } else if (
      licenceStatus === CONST.APPLICATION_STATUS_UNREAD ||
      licenceStatus === CONST.APPLICATION_STATUS_OPENED
    ) {
      if (isRenewalTypeLicencingSubType(licencingSubType)) {
        return <span className="submitted">Submitted for renewal</span>;
      }
      return <span className="submitted">Submitted</span>;
    } else if (licenceStatus === CONST.APPLICATION_STATUS_PENDING_AGENCY) {
      if (isRenewalTypeLicencingSubType(licencingSubType)) {
        return <span className="submitted">Submitted for renewal</span>;
      }
      return <span className="submitted">Submitted</span>;
    } else if (licenceStatus === CONST.APPLICATION_STATUS_PENDING) {
      return <span className="pending">Pending</span>;
    } else if (licenceStatus === CONST.APPLICATION_STATUS_ACTION_REQUIRED) {
      return <span className="cancelled">Action required</span>;
    } else if (licenceStatus === CONST.APPLICATION_STATUS_APPROVED_ISSUED) {
      return <span className="active">Approved</span>;
    } else if (
      licenceStatus === CONST.APPLICATION_STATUS_PENDING_PAYMENT &&
      licenceSubType !== CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION &&
      !isRenewalTypeLicencingSubType(licencingSubType)
    ) {
      return (
        <span className="pending_payment">
          <NavigationLinkButton
            text="Continue draft"
            style={{
              backgroundColor: "transparent",
              paddingLeft: "0px"
            }}
            onClick={() => {
              // set the collector as current collector
              // and navigate to the details screen
              onActionClick("continue_draft", agentApplication.applicationId, licencingSubType);
            }}
          />
        </span>
      );
    }

    // the applications applied for renewal were anyway approved!
    if (isRenewalTypeLicencingSubType(licencingSubType)) {
      return <span className="active">Active</span>;
    }

    return null;
  };

  const actionsObj = useMemo(() => {
    const isMortgagePrincipalBroker = () => {
      return (
        licencingSubType === CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION ||
        licencingSubType === CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION
      );
    };

    const isMortgage = () => {
      return (
        licencingSubType === CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION ||
        licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION ||
        licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION ||
        licencingSubType === CONST.LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION ||
        licencingSubType === CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION ||
        licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION ||
        licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION ||
        licencingSubType === CONST.LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION
      );
    };

    const action = (action) => () =>
      onActionClick(action, agentApplication.applicationId, licencingSubType);

    /*
        Do not allow edit, remove or cancel functionality to the principal broker yet.
       */
    if (isMortgage() && isAgentRenewalEnable) {
        let thirdButtonText;
        if (
          isMortgagePrincipalBroker() &&
          !(licenceStatus === CONST.LICENCE_STATUS_EXPIRED || licenceStatus === CONST.APPLICATION_STATUS_PENDING_PAYMENT)
        ) {
          thirdButtonText = "";
        } else {
          thirdButtonText = "Cancel Licence";
        }

        if (
          licenceStatus === CONST.LICENCE_STATUS_ACTIVE ||
          licenceStatus === CONST.LICENCE_STATUS_EXPIRED
        ) {
          return {
            primaryButtonText: "Renew",
            onClick: action("renew_application"),
            secondaryButtonText: "Print licence",
            onSecondaryClick: action("print_licence"),
            thirdButtonText
          };
        } else if (licenceStatus === CONST.APPLICATION_STATUS_PENDING_PAYMENT) {
          return {
            primaryButtonText: "Resume Renewal",
            onClick: action("resume_application"),
            secondaryButtonText: "Print licence",
            onSecondaryClick: action("print_licence"),
            thirdButtonText
          };
        }
    }

    if (isRenewalTypeLicencingSubType(licencingSubType) && !isMortgage()) {
      if (
        licenceStatus === CONST.APPLICATION_STATUS_PENDING_PAYMENT ||
        licenceStatus === CONST.APPLICATION_STATUS_PENDING_AGENCY ||
        licenceStatus === CONST.APPLICATION_STATUS_UNDER_REVIEW ||
        licenceStatus === CONST.APPLICATION_STATUS_UNREAD ||
        licenceStatus === CONST.APPLICATION_STATUS_OPENED ||
        licenceStatus === CONST.APPLICATION_STATUS_PENDING
      ) {
        return {
          primaryButtonText: "View Only",
          onClick: action("agent_details"),
          secondaryButtonText: "Print licence",
          onSecondaryClick: action("print_licence")
        };
      }
    }

    switch (licenceStatus) {
      case CONST.LICENCE_STATUS_ACTIVE:
        return {
          primaryButtonText: !isMortgagePrincipalBroker() ? "Edit" : "",
          onClick: !isMortgagePrincipalBroker() ? action("agent_details") : "",
          secondaryButtonText: "Print licence",
          onSecondaryClick: action("print_licence"),
          thirdButtonText: !isMortgagePrincipalBroker() && isMortgage() ? "Cancel Licence" : ""
        };
      case CONST.APPLICATION_STATUS_APPROVED_ISSUED:
        return {
          primaryButtonText: !isMortgagePrincipalBroker() ? "Edit" : "",
          onClick: !isMortgagePrincipalBroker() ? action("agent_details") : "",
          secondaryButtonText: "Print licence",
          onSecondaryClick: action("print_licence")
        };
      case CONST.APPLICATION_STATUS_PENDING_PAYMENT:
        return {
          primaryButtonText: !isMortgagePrincipalBroker() ? "Edit" : "",
          onClick: !isMortgagePrincipalBroker() ? action("continue_draft") : "",
          secondaryButtonText: "Remove application",
          onSecondaryClick: action("remove")
        };
      case CONST.APPLICATION_STATUS_DENIED:
      case CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT:
      case CONST.APPLICATION_STATUS_WITHDRAWN_APPROVED:
      case CONST.LICENCE_STATUS_REVOKED:
      case CONST.LICENCE_STATUS_SUSPENDED:
        return {
          primaryButtonText: !isMortgagePrincipalBroker() ? "View Only" : "",
          onClick: !isMortgagePrincipalBroker() ? action("agent_details") : "",
          secondaryButtonText: "",
          onSecondaryClick: () => {}
        };
      case CONST.LICENCE_STATUS_EXPIRED:
      case CONST.APPLICATION_STATUS_ACTION_REQUIRED:
      case CONST.APPLICATION_STATUS_PENDING:
      case CONST.APPLICATION_STATUS_PENDING_AGENCY:
      case CONST.APPLICATION_STATUS_SUBMITTED:
      case CONST.APPLICATION_STATUS_UNDER_REVIEW:
      case CONST.APPLICATION_STATUS_UNREAD:
      default:
        return null;
    }
  }, [
    licenceStatus,
    agentApplication.applicationId,
    licencingSubType,
    onActionClick,
    isAgentRenewalEnable
  ]);

  const submittedAt = useMemo(() => {
    switch (licenceStatus) {
      case CONST.APPLICATION_STATUS_ACTION_REQUIRED:
      case CONST.APPLICATION_STATUS_SUBMITTED:
      case CONST.APPLICATION_STATUS_UNDER_REVIEW:
      case CONST.APPLICATION_STATUS_UNREAD:
      case CONST.APPLICATION_STATUS_PENDING:
      case CONST.APPLICATION_STATUS_PENDING_AGENCY:
        return `Submitted on ${agentApplication.submittedDate}`;
      case CONST.APPLICATION_STATUS_PENDING_PAYMENT:
        if (isRenewalTypeLicencingSubType(licencingSubType)) {
          return "Payment pending for renewal";
        }
        return agentApplication.lastModified
          ? `Last modified on ${agentApplication.lastModified}`
          : "";
      case CONST.LICENCE_STATUS_REVOKED:
        return `Revoked on ${agentApplication.lastModified}`;
      case CONST.APPLICATION_STATUS_DENIED:
        return `Denied on ${agentApplication.lastModified}`;
      case CONST.LICENCE_STATUS_SUSPENDED:
        return `Suspended on ${agentApplication.lastModified}`;
      case CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT:
      case CONST.APPLICATION_STATUS_WITHDRAWN_APPROVED:
        return agentApplication.lastModified
          ? `Withdrawn on ${agentApplication.lastModified}`
          : null;
      default:
        if (markedDoNotRenew) {
          return "Not submitted for renewal";
        }
        return null;
    }
  }, [
    licenceStatus,
    agentApplication.submittedDate,
    agentApplication.lastModified,
    licencingSubType,
    markedDoNotRenew
  ]);

  const handleCancelAgentLicence = () => {
    setShowLicenceCancelSpinner(true);
    dispatch(
      fetchApplicationWithIdAndSetStore(parseInt(agentApplication.applicationId), false, true)
    )
      .then((applicationData) => {
        dispatch(setCurrentAgentApplicationId(parseInt(applicationData.id)));

        dispatch(withdrawAgentApplication(parseInt(applicationData.id)));
        const applicationType = applicationTypeFromLicenceSubType(
          agentApplication.licencingSubType
        );
        dispatch(saveBusinessLicenceApplicationData(applicationType))
          .then((applicationItem) => {
            setShowLicenceCancelDialog(false);
            setShowLicenceCancelSpinner(false);
            dispatch(setCurrentAgentApplicationId(parseInt(null)));
          })
          .catch((error) => {
            console.error(error);
            setShowLicenceCancelSpinner(false);
          });
      })
      .catch((error) => {
        console.error(error);
        setShowLicenceCancelSpinner(false);
      });
  };

  return (
    <div className="agentCard">
      <div className="agentCard_title">
        <div className="agentCard_title_text">
          <div className="agentCard_title_main">
            {titleStringFromLicenceSubType(licencingSubType)}
          </div>
          <div className="agentCard_title_status">
            {agentLicenceStatusComponent(licencingSubType)}
          </div>
          <div className="agentCard_title_licence">{licenceNumber}</div>
          {endDate && <div className="agentCard_title_validity">Valid Until {endDate}</div>}
          {cepRipExpiryDate && <div className="agentCard_title_validity">Education Valid Until {humanReadableDate(cepRipExpiryDate)}</div>}
          {submittedAt && <div className="agentCard_title_validity">{submittedAt}</div>}
        </div>
        {/* <div className="agentCard_title_icon">
                    <img 
                        src={iconFromApplicationStatus()}
                        alt="img" 
                    />
                </div> */}
      </div>
      <div className="agentCard_body">
        <div className="agentCard_body_name" style={{ fontSize: "1.5em" }}>
          {agentName}
          {licencingSubType === CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION && (
            <div style={{ fontSize: ".5em" }}>(Principal broker)</div>
          )}
        </div>

        <div className="agentCard_body_links">
          {actionsObj && (
            <div>
              {actionsObj.primaryButtonText && (
                <Button
                  style={{ marginBottom: 5 }}
                  text={actionsObj.primaryButtonText}
                  onClick={actionsObj.onClick}
                  id="ns-edit"
                  buttonType="regular_primary"
                />
              )}

              {actionsObj.secondaryButtonText && (
                <NavigationLinkButton
                  style={{ marginBottom: 5 }}
                  text={actionsObj.secondaryButtonText}
                  onClick={actionsObj.onSecondaryClick}
                />
              )}

              {actionsObj.thirdButtonText && (
                <Button
                  showSpinner={false}
                  style={{ marginBottom: 5 }}
                  onClick={() => setShowLicenceCancelDialog(true)}
                  text={"Cancel Licence"}
                  buttonType="regular_primary"
                />
              )}
            </div>
          )}
        </div>
      </div>
      {showLicenceCancelDialog ? (
        <Modal
          appElement={document.getElementById("root")}
          isOpen={showLicenceCancelDialog}
          contentLabel="cancelAgentLicenceDialog"
          onRequestClose={() => {
            setShowLicenceCancelDialog(false);
          }}
          shouldCloseOnEsc={false}
          shouldCloseOnOverlayClick={false}
          className="modalDialogContent"
          overlayClassName="modalOverlayClassName"
          closeTimeoutMS={150}
        >
          <div className="row pull-right">
            <div
              className="col-lg-1 closeButton"
              onClick={() => {
                setShowLicenceCancelDialog(false);
              }}
            >
              <i className="fa fa-2x fa-times"></i>
            </div>
          </div>
          <Header header={"Cancel Licence"} />
          <p>
            {
              "You are about to cancel your broker licence.  Are you sure you want to cancel the broker license?"
            }
          </p>
          <p>
            Note: Do not cancel this licence if you want to transfer this broker to another
            brokerage. Contact mortgageregulation@novascotia.ca for more information.
          </p>
          <Button
            onClick={() => {
              handleCancelAgentLicence();
            }}
            buttonType={"regular_primary"}
            text="Yes"
            style={{ marginTop: "20px" }}
            showSpinner={showLicenceCancelSpinner}
          />
          <Button
            onClick={() => {
              setShowLicenceCancelDialog(false);
            }}
            buttonType={"regular_primary"}
            text="No"
            style={{ marginTop: "20px", marginLeft: 50 }}
          />
        </Modal>
      ) : null}
    </div>
  );
};
